import { render, staticRenderFns } from "./StorageRoomBaseData.vue?vue&type=template&id=71a99ad5"
import script from "./StorageRoomBaseData.vue?vue&type=script&lang=js"
export * from "./StorageRoomBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports